module.exports = __webpack_public_path__ + "img/selected1-min.f65f68b1.png";